// Клиент `GET /api/v1/modules` — состав включённых прикладных модулей
// сервера (ADR-0083, `docs/spec/core/di.md`).
//
// Типы вшиты руками параллельно с backend Pydantic-схемой
// (`backend/core/di/schemas.py`). Состав — подсказка интерфейсу, а не
// авторизация: доступ к действию проверяет ручка действия.

import { authedFetch } from "../../auth/authedFetch";

export interface EnabledModulesResponse {
  /** Имена включённых модулей по возрастанию; ядро не входит. */
  readonly modules: readonly string[];
}

export async function fetchEnabledModules(): Promise<EnabledModulesResponse> {
  const response = await authedFetch("/api/v1/modules", {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`modules: HTTP ${String(response.status)}`);
  }
  return (await response.json()) as EnabledModulesResponse;
}
